import Vue from 'vue'
import Vuex from 'vuex'

import Dashboard from '@/store/modules/dashboard'
import Questions from '@/store/modules/questions'
import Questionnaires from '@/store/modules/questionnaire'
import Repositories from '@/store/modules/repository'
import Resources from '@/store/modules/resources'
import User from '@/store/modules/user'
import UserQuestionnaire from '@/store/modules/userQuestionnaire'
import i18n from '@/plugins/i18n'

Vue.use(Vuex)
export const INFO_MSG = 'valid'
export const ERROR_MSG = 'cancel'

export default new Vuex.Store({
  state: {
    notification: {
      level: '',
      message: '',
      timeout: 0
    }
  },
  getters: {
    notification: state => state.notification
  },
  mutations: {
    UPDATE_NOTIFICATION: (state, newNotification) => {
      state.notification = { ...newNotification, timestamp: Date.now() }
    }
  },
  actions: {
    displaySaveError: ({ dispatch }, { error, reason }) => {
      dispatch(
        'displayError',
        {
          action: reason + '<br>' + i18n.t('store.global.cannotSave'),
          error
        }
      )
    },
    displayLoadError: ({ dispatch }, error) => {
      dispatch('displayError', { action: i18n.t('store.global.cannotLoad'), error })
    },
    displayError: ({ commit }, { action, error }) => {
      let reason
      if (error.response) {
        const code = error.response.status
        reason = code === 500
          ? i18n.t('store.global.serverError')
          : i18n.t('store.global.statusError', { code })
      } else if (error.request) {
        reason = i18n.t('store.global.timeout')
      } else {
        reason = i18n.t('store.global.unknownError')
      }
      const message = action + '<br/>' + reason
      commit(
        'UPDATE_NOTIFICATION', {
          level: ERROR_MSG,
          timeout: 6000,
          message
        }
      )
    },
    displayInfo: ({ commit }, message) => {
      commit(
        'UPDATE_NOTIFICATION', {
          level: INFO_MSG,
          timeout: 2000,
          message
        }
      )
    }
  },
  modules: {
    Dashboard,
    Questions,
    Questionnaires,
    Repositories,
    Resources,
    User,
    UserQuestionnaire
  }
})
